import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const PlusIcon = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M13 4C13 3.5 12.5523 3 12 3C11.4477 3 11 3.5 11 4L11 11L4 11C3.5 11 3 11.4477 3 12C3 12.5523 3.5 13 4 13L11 13L11 20C11 20.5 11.4477 21 12 21C12.5523 21 13 20.5 13 20L13 13L20 13C20.5 13 21 12.5523 21 12C21 11.4477 20.5 11 20 11L13 11L13 4Z"
    fill="currentColor"
  />,
  "PlusIcon"
);
